import React from "react";
import {
    ClearFiltersButton,
    ContentSection,
    createListTableColumns,
    Grid,
    GridColumn,
    GridRow,
    ListTable,
    NamedProperty,
    SearchBox,
    Stack
} from "sprint-common-web";

import { HeaderBreadcrumb } from "../../../common/ui/layout/header/header-breadcrumb/HeaderBreadcrumb";
import { PageHeader } from "../../../common/ui/layout/header/PageHeader";
import { adminRoutes } from "../../AdminRoutes";
import { EditUserButton } from "./buttons/EditUserButton";
import { useUserListingFilters } from "./hooks/useUserListingFilters";
import { useUsersListingData } from "./hooks/useUsersListingData";

export interface UserItem {
    name: string;
    id: string;
    originators: NamedProperty[];
    isModified: boolean;
}

export const UsersListing: React.FC = () => {
    const { filters, setSort, setPage, setPageSize, setName, clearFilters } = useUserListingFilters();

    const { items, totalItems, isLoading } = useUsersListingData(filters);

    const columns = createListTableColumns<UserItem>([
        {
            type: "basic",
            key: "name",
            name: "Name",
            minWidth: 100,
            maxWidth: 300,
            isSortable: true
        },
        {
            type: "basic",
            key: "originators",
            name: "Originators",
            minWidth: 70,
            maxWidth: 280,
            isSortable: false,
            isMultiline: true,
            onRender: (item) => {
                return <>{item?.originators.map((p) => p.name).join(", ") ?? "-"}</>;
            }
        },
        {
            type: "buttons",
            key: "actions",
            name: "Actions",
            minWidth: 64,
            maxWidth: 64,
            buttons: [
                {
                    id: "edit",
                    render: EditUserButton
                }
            ]
        }
    ]);

    return (
        <>
            <PageHeader>
                <HeaderBreadcrumb routes={adminRoutes} />
            </PageHeader>
            <ContentSection header={"Users"}>
                <Grid>
                    <GridRow>
                        <GridColumn sm={2}>
                            <SearchBox
                                placeholder="Name"
                                onChange={setName}
                                value={filters.name}
                                testId="users-filters-name"
                            />
                        </GridColumn>

                        <GridColumn sm={4}>
                            <Stack horizontalAlign="end">
                                <ClearFiltersButton isLabeled={true} onClear={clearFilters} />
                            </Stack>
                        </GridColumn>
                    </GridRow>
                    <GridRow>
                        <GridColumn sm={12}>
                            <ListTable
                                columns={columns}
                                items={items}
                                pagination={{
                                    page: filters.page,
                                    pageSize: filters.pageSize,
                                    totalItems: totalItems,
                                    onPageChange: setPage,
                                    onPageSizeChange: setPageSize
                                }}
                                sort={{ by: filters.sortBy, order: filters.sortOrder }}
                                onSortChange={setSort}
                                isLoading={isLoading}
                                layoutMode="fixedColumns"
                            />
                        </GridColumn>
                    </GridRow>
                </Grid>
            </ContentSection>
        </>
    );
};
